var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDistanceIcon = function SvgDistanceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E8202C",
    fillRule: "evenodd",
    clipPath: "url(#distance-icon_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 1.126c-1.474 0-2.737 1.268-2.737 2.8 0 1.538 1.262 2.696 2.71 3.622a.07.07 0 0 0 .056 0c1.445-.914 2.708-2.089 2.708-3.622s-1.263-2.8-2.737-2.8m-4 2.8C10 1.683 11.83-.16 14-.16s4 1.843 4 4.086c0 2.295-1.87 3.809-3.32 4.723l-.01.006-.01.006a1.31 1.31 0 0 1-1.32 0l-.011-.006-.011-.007C11.875 7.728 10 6.23 10 3.926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.303 3.685a.845.845 0 0 1 .845-.845h.007a.844.844 0 0 1 0 1.69h-.007a.844.844 0 0 1-.845-.845M3.167 12.769a1.9 1.9 0 0 0-1.343 3.246 1.9 1.9 0 1 0 2.687-2.689 1.9 1.9 0 0 0-1.344-.557M0 14.671a3.17 3.17 0 0 1 3.167-3.17 3.167 3.167 0 0 1 3.168 3.17 3.17 3.17 0 0 1-3.168 3.169A3.167 3.167 0 0 1 0 14.67m3.379-7.606c0-1.838 1.702-3.169 3.59-3.169h1.266a.633.633 0 0 1 0 1.268H6.968c-1.377 0-2.322.94-2.322 1.901s.945 1.902 2.322 1.902h2.534c1.888 0 3.59 1.33 3.59 3.169s-1.702 3.169-3.59 3.169H8.235a.633.633 0 1 1 0-1.268h1.267c1.378 0 2.323-.94 2.323-1.901s-.945-1.902-2.323-1.902H6.968c-1.887 0-3.59-1.33-3.59-3.169"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "distance-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgDistanceIcon;